import React from 'react';
import S from './Checkbox.styles';
const Checkbox = React.forwardRef(({ className, id, labelText, name, value, ...otherProps }, ref) => {
    return (React.createElement(S.Container, { className: className },
        React.createElement(S.CheckboxItem, { htmlFor: id },
            React.createElement(S.CheckboxInput, { ref: ref, id: id, name: name, value: value, ...otherProps }),
            React.createElement(S.CheckboxText, null,
                labelText,
                React.createElement(S.Tick, null)))));
});
Checkbox.displayName = 'Checkbox';
export default Checkbox;
